import { render, staticRenderFns } from "./UpdateCardDetails.vue?vue&type=template&id=5ac0e14c&scoped=true&"
import script from "./UpdateCardDetails.vue?vue&type=script&lang=js&"
export * from "./UpdateCardDetails.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCardDetails.vue?vue&type=style&index=0&id=5ac0e14c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac0e14c",
  null
  
)

export default component.exports